import { SecureStorage } from '@aparajita/capacitor-secure-storage';
import { env } from './env';

/**
 * Persistencia del refresh token.
 *  - Android: almacenamiento seguro (Android Keystore) vía plugin nativo.
 *  - Web: el refresh token vive en una cookie httpOnly que JavaScript no puede leer;
 *    aquí no se guarda nada.
 */
const KEY = 'tcrd.refresh';

export const sessionStorageSecure = {
  async getRefresh(): Promise<string | null> {
    if (!env.isNative) return null;
    try {
      const v = await SecureStorage.get(KEY);
      return typeof v === 'string' ? v : null;
    } catch {
      return null;
    }
  },
  async setRefresh(token: string | undefined) {
    if (!env.isNative || !token) return;
    await SecureStorage.set(KEY, token);
  },
  async clear() {
    if (!env.isNative) return;
    try {
      await SecureStorage.remove(KEY);
    } catch {
      /* ya vacío */
    }
  },
};
